import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush,
} from "recharts";

const ChartLine = ({ data, dataKey = "", max, min = 0 }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "300px",
        width: "100%",
        paddingBlock: "20px",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={"100%"}
          height={"100%"}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" fontSize={12} />
          <YAxis type="number" domain={[min, max]} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey={"median"}
            stroke="#f00"
            // stroke="#8884d8"
            dot={{ r: 0 }}
            strokeWidth={1.5}
          />
          <Line
            type="monotone"
            dataKey={dataKey}
            // stroke="#82ca9d"
            dot={{ r: 0 }}
            strokeWidth={3}
          />
          {/* <Brush /> */}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
export default ChartLine;
